export enum PolicyEnum {
    TravelProtectPlus = "TP",
    LifestyleProtectPlus = "LP",
    BillProtect = "BP",
}

export const PolicyLabelMap = {
    [PolicyEnum.TravelProtectPlus]: "Travel Protect Plus",
    [PolicyEnum.LifestyleProtectPlus]: "Lifestyle Protect Plus",
    [PolicyEnum.BillProtect]: "Bill Protect",
};

export function getPolicyLabel(policy: PolicyEnum): string {
    return PolicyLabelMap[policy] || "";
}

export enum PolicyStatusEnum {
    Active = "Active",
    Expired = "Expired",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
    Lapsed = "Lapsed",
}
